import { plaintextValidator, numberValidator, equalityCheck } from '../fields';

const config = { mandatory: true, customError: `^Required` };

function getValidatorType(field) {
  switch (field.uiDataType) {
    case 'password':
      return plaintextValidator(config);
    case 'number':
      return numberValidator(config);
    default:
      return plaintextValidator(config);
  }
}

function getEqualityValidator(field, nestedAttribute) {
  const { type } = field;
  const name = nestedAttribute
    ? `${nestedAttribute}.${field?.name}`
    : field?.name;
  const compareField = nestedAttribute
    ? `${nestedAttribute}.${field.compareField}`
    : field?.compareField;

  if (type === 'password') {
    return equalityCheck({
      field: name,
      compareField,
      customError: `^ Passwords do not match.`
    });
  }

  return {};
}

function DynamicFormValidation(fields, nestedAttribute) {
  const result = {};

  fields.map((field) => {
    result[`${nestedAttribute}.${field.name}`] = getValidatorType(field);
  });

  return result;
}
export function dynamicFormValidationWithEquality(fields, nestedAttribute) {
  let result = {};
  fields.forEach((field) => {
    result = {
      ...result,
      ...getEqualityValidator(field, nestedAttribute)
    };
  });

  return result;
}

export default DynamicFormValidation;
